import { createFileRoute, Outlet } from "@tanstack/react-router"
import { Crumb } from "modules/shared/lib/breadcrumbs"

export const Route = createFileRoute("/_base/_auth/backoffice/flags")({
  component: () => <Outlet />,
  loader: ({ route: { fullPath } }) =>
    new Crumb({ fullPath, title: (t) => t("backoffice.flags.title") }),
})
